import { useMemo, useState } from "react";
import { BarChart } from "@mantine/charts";
import { Group, Pagination, Select, Text } from "@mantine/core";
import React from "react";
import { getHardcodedColor } from "../../utils";

const PaginatedBarChart = ({ data, nodeType, height }) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState<string | null>('20');

  const sortedData = useMemo(() => {
    return [...data].sort((a, b) => b.count - a.count);
  }, [data]);

  const totalPages = Math.ceil(sortedData.length / Number(pageSize));
  const paginatedData = sortedData.slice(
    (page - 1) * Number(pageSize),
    page * Number(pageSize)
  );

  return (
    <div style={{
      height: "100%",
      width: "100%",
      display: "flex",
      flexDirection: "column",
    }}>
      <div
        style={{
          height: "100%",
          width: "100%",
          maxWidth: `${paginatedData.length * 80}px`,
          minWidth: "300px"
        }}
      >
        {height && <BarChart
          h={height - 40}
          yAxisProps={{ width: 80, domain: [0, Math.max(...data.map(d => d.count))] }}
          data={paginatedData}
          dataKey="label"
          orientation="horizontal"
          series={[{ name: "count", color: getHardcodedColor(nodeType) }]}
          withBarValueLabel
        />}
      </div>
      <Group>
        <Group style={{ paddingTop: 15 }}>
          <Text c="dimmed" size="sm">Bars per page</Text>
          <Select
            style={{ width: 80 }}
            size="xs"
            value={pageSize}
            onChange={setPageSize}
            data={["10", "20", "30", "40", "50"]}
          />
        </Group>
        <Pagination
          total={totalPages}
          value={page}
          onChange={setPage}
          mt="md"
        />
      </Group>
    </div>
  );
};

export default PaginatedBarChart;
